import React from 'react'
import { useTranslation } from 'react-i18next'
import LandingpageLayout from '../../global/LandingpageLayout';

const Fantasy = (props) => {
  const { t } = useTranslation()
  const {currentPage, numPages, lang} = props.pageContext;
  const { fantasy, stories, fantasies, seoContent } = props.pageContext.data;
  const pageHeadline = seoContent?.heroTitle || t('placeholder.fantasy.heroTitle', {fantasy: fantasy[lang].fantasy})
  const pageDescription = seoContent?.heroDescription || t('placeholder.fantasy.heroDescription', {fantasy: fantasy[lang].fantasy})
  const metaHeadline = seoContent?.metaHeadline || t('placeholder.fantasy.metaHeadline', {fantasy: fantasy[lang].fantasy})
  const metaDesc = seoContent?.metaDescription || t('placeholder.fantasy.metaDescription', {fantasy: fantasy[lang].fantasy})
  const cta = seoContent?.cta || t('placeholder.fantasy.cta', {fantasy: fantasy[lang].fantasy})
  const faq = seoContent?.faq || t('placeholder.fantasy.faq', {returnObjects: true, fantasy: fantasy[lang].fantasy})
  const testimonials = seoContent?.testimonials || t('placeholder.fantasy.testimonials', {returnObjects: true, fantasy: fantasy[lang].fantasy})
  const tagSliderTitle = seoContent?.tagSliderTitle || t('placeholder.fantasy.tagSliderWave', {fantasy: fantasy[lang].fantasy})

  return (
    <LandingpageLayout
      pageHeadline={pageHeadline}
      pageDescription={pageDescription}
      metaHeadline={metaHeadline}
      metaDesc={metaDesc}
      testimonials={testimonials}
      faq={faq}
      cta={cta}
      paginationUrl={`${t('urls.fantasy')}${fantasy[lang].slug}/`}
      currentPage={currentPage}
      numPages={numPages}
      stories={stories}
      tags={fantasies.map(fantasy => ({label: fantasy[lang].fantasy, link: `${t('urls.fantasy')}${fantasy[lang].slug}/`}))}
      tagShowAllLink={`${t('urls.fantasy')}`} 
      tagSliderTitle={tagSliderTitle}
      imageUrl={fantasy.imageUrl}
    />
  )
}

export default Fantasy
